import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { userSelector } from 'slices/userSlice';
import { getTimezoneByRole } from 'helpers/timezoneHelper';

function useTimeZoneClock(date) {
  const { user } = useSelector(userSelector);
  const tz = getTimezoneByRole(user?.role);

  const [currentTime, setCurrentTime] = useState(
    moment.utc(date, "DD-MM-YYYY HH:mm").tz(tz).format("YYYY-MM-DD HH:mm")
  );

  useEffect(() => {
    setCurrentTime(
      moment.utc(date, "DD-MM-YYYY HH:mm").tz(tz).format("YYYY-MM-DD HH:mm")
    );
  }, [date, tz]);

  return currentTime;
}

export default useTimeZoneClock;
